module.exports = __webpack_public_path__ + "img/hzLogo2.669eb416.png";